import { useEffect } from "react";
import AdminPayroll from "../admin/AdminPayroll";
import useAdminPayroll from "../../hooks/admin/useAdminPayroll";
import { API_BASE_URL as API } from "../../apiConfig";

const getErrorMessage = (error, defaultMessage = "操作失败") => {
  const detail = error.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object") return detail.message_zh || detail.message || detail.error || defaultMessage;
  return error.message || defaultMessage;
};

export default function FleetPayroll({ language = "zh", onLanguageChange }) {
  const payrollProps = useAdminPayroll({
    apiBaseUrl: API,
    getErrorMessage,
    payrollApiPath: "/internal/payroll",
    driverImportApiPath: "/internal/payroll/driver-import-options",
    authTokenKey: "internal_token",
  });

  useEffect(() => {
    payrollProps.fetchPayrollEmployees();
    payrollProps.fetchPayrollRuns();
    payrollProps.fetchCompanySettings();
    payrollProps.fetchAnnualPayroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-6">
      <AdminPayroll payrollProps={payrollProps} language={language} onLanguageChange={onLanguageChange} />
    </div>
  );
}
